export const getCuCode = () => {
    const params = new URL(window.location.href).searchParams;
    return params.get('cu');
};

export const getToken = () => {
    const params = new URL(window.location.href).searchParams;
    return params.get('token');
};

export const getLanguage = () => {
    const params = new URL(window.location.href).searchParams;
    return params.get('lang');
};

export const groupBy = (key) => (array) =>
    array.reduce((objectsByKeyValue, obj) => {
        const value = obj[key];
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
    }, {});

export const checkDate = (dateType) => {
    if (dateType === 'birthday') {
        return (date) => {
            const today = new Date();
            const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
            const userDate = new Date(date);
            return userDate <= eighteenYearsAgo && userDate > new Date(1900, 1, 1);
        }
    }
    else if (dateType === 'funds')
        return (date) => new Date(date) < new Date(9999, 11, 31) && new Date(date) >= new Date(Date.now() - 86400000);
    else
        return (date) => new Date(date) < new Date(9999, 11, 31) && new Date(date) > new Date(1900, 1, 1);
};

export const checkName = (name) => {
    return !/\d/.test(name);
};

export const checkAccents = (word) => {
    const accents = ['á','à','ã','â','é','è','ê','í','ì','î','õ','ó','ò','ô','ú','ù','û'];
    let accented = false;
    accents.forEach(acc => {
        if (word.toLowerCase().includes(acc))
            accented = true;
    });
    return !accented;
};

export const checkSpecialChars = (word) => {
    return !/^[^a-zA-Z0-9]+$/.test(word);
};

export const bindForm = (setValue, data) => {
    if (!data) return;
    if (data.length > 1) {
        setValue('loan.coBorrower', true);
    }
    data.forEach((applicant, i) => {
        setValue(`applicants[${i}].firstName`, applicant.firstName || '');
        setValue(`applicants[${i}].lastName`, applicant.lastName || '');
        setValue(`applicants[${i}].middleName`, applicant.middleName || '');
        setValue(`applicants[${i}].phone`, applicant.phone || '');
        setValue(`applicants[${i}].dateOfBirth`, applicant.dateOfBirth || '');
        setValue(`applicants[${i}].email`, applicant.email || '');
        setValue(`applicants[${i}].sin`, applicant.sin || '');
        setValue(`applicants[${i}].memberKey`, applicant.memberKey || '');
        setValue(`applicants[${i}].address.location`, applicant.address.location || '');
        setValue(`applicants[${i}].address.city`, applicant.address.city || '');
        setValue(
            `applicants[${i}].address.occupationType`,
            applicant.address.occupationType || ''
        );
        setValue(`applicants[${i}].address.pobox`, applicant.address.pobox || '');
        setValue(`applicants[${i}].address.postalCode`, applicant.address.postalCode || '');
        setValue(`applicants[${i}].address.province`, applicant.address.province || '');
        setValue(`applicants[${i}].address.since`, applicant.address.since || '');
        setValue(`applicants[${i}].address.unit`, applicant.address.unit || '');

        setValue(
            `applicants[${i}].employments[0].employer`,
            applicant.employments[0].employer || ''
        );
        setValue(
            `applicants[${i}].employments[0].occupation`,
            applicant.employments[0].occupation || ''
        );
        setValue(`applicants[${i}].employments[0].phone`, applicant.employments[0].phone || '');
        setValue(`applicants[${i}].employments[0].since`, applicant.employments[0].since || '');
        setValue(
            `applicants[${i}].employments[0].status`,
            applicant.employments[0].status || ''
        );
        setValue(
            `applicants[${i}].employments[0].earning`,
            applicant.employments[0].earning || ''
        );

        if (applicant.assets.length > 0) {
            applicant.assets.forEach((asset, j) => {
                setValue(`applicants[${i}].assets[${j}].type`, asset.type || '');
                setValue(`applicants[${i}].assets[${j}].value`, asset.value || '');
                setValue(`applicants[${i}].assets[${j}].id`, asset.id || '');
            });
        }
        if (applicant.liabilities.length > 0) {
            applicant.liabilities.forEach((lib, j) => {
                setValue(`applicants[${i}].liabilities[${j}].type`, lib.type || '');
                setValue(`applicants[${i}].liabilities[${j}].balance`, lib.payment || '');
                setValue(`applicants[${i}].liabilities[${j}].id`, lib.id || '');
            });
        }
    });
};
